<input type="radio" name="selection" (click)="onSelection($event)" aria-label="selection">

